import Logo from "@/components/feature/Logo";
import { LINKS, WA_LINKS } from "@/constants/site";

export default function Footer() {
  return (
    <footer className="w-full bg-ink pb-24 pt-10 md:pb-28 md:pt-14">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center px-4 text-center md:px-6">
        <Logo className="justify-center" imgClassName="h-20 w-auto md:h-24" />

        <p className="mt-5 text-sm text-sand">CLEM by Cerón · Armenia, Quindío, Colombia</p>

        <div className="mt-6 flex items-center gap-4">
          <a
            href={LINKS.instagramClem}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram de CLEM by Cerón"
            className="flex h-12 w-12 items-center justify-center rounded-full border border-malva/50 text-cream transition-colors hover:border-peach hover:text-peach"
          >
            <i className="ri-instagram-line text-xl" aria-hidden="true" />
          </a>
          <a
            href={WA_LINKS.info}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp de CLEM by Cerón"
            className="flex h-12 w-12 items-center justify-center rounded-full border border-malva/50 text-cream transition-colors hover:border-peach hover:text-peach"
          >
            <i className="ri-whatsapp-line text-xl" aria-hidden="true" />
          </a>
        </div>

        <p className="mt-8 max-w-xl text-xs leading-relaxed text-sand">
          Los precios incluyen impuesto al consumo de 8%. El servicio de propina es voluntario
          (Ley 1935 de 2018).
        </p>
        <p className="mt-3 text-xs text-sand/80">
          © 2026 CLEM by Cerón. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}